<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 품번 -->
							<th class="col-1">* {{ getMessage_('QWCC000956') }}</th>
							<td class="position-relative">
								<template v-if="detailForm.partNo">
									{{ detailForm.partNo }}
								</template>
								<template v-else>
									<span style="color: #d3d3d3">{{ getMessage_('QWCC001656') }}</span>
								</template>
								<template v-if="!detailForm.altrNo">
									<span class="unit input-icon" @click="onPartPopup" v-show="!overInspect"> <i class="icon-sf-search" /> </span>
								</template>
							</td>
							<!--  변경번호 -->
							<th class="col-1">{{ getMessage_('QWCC000029') }}</th>
							<td>{{ detailForm.altrNo }}</td>
							<!-- 변경유형 -->
							<th class="col-1">* {{ getMessage_('QWCC001086') }} ①</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.altrTypeCd"
									:options="altrTypeCdList"
									:onChange="val => setDetailForm(val, 'altrTypeCd')"
									:placeholder="getMessage_('QWCC001086')"
									:disabled="noInspect"
								/>
							</td>
							<!-- ISIR 승인구분 -->
							<th class="col-1">{{ getMessage_('QWCC000028') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="getIsirCsetScnNm_"
									:options="isirCsetScnCd"
									:onChange="val => setDetailForm(val, 'isirCsetScnCd')"
									:placeholder="getMessage_('QWCC000028')"
									disabled
								/>
							</td>
							<!-- 소싱구분 -->
							<th class="col-1">{{ getMessage_('QWCC000981') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.partGCd"
									:options="partGCdList"
									:onChange="val => setDetailForm(val, 'partGCd')"
									:placeholder="getMessage_('QWCC000981')"
									disabled
								/>
							</td>
						</tr>
						<tr>
							<!-- 품명 -->
							<th>{{ getMessage_('QWCC000957') }}</th>
							<td>{{ detailForm.partNm }}</td>
							<!-- 변경일자 -->
							<th>* {{ getMessage_('QWCC001742') }}</th>
							<td>
								<el-date-picker
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:value="detailForm.altrDd"
									@input="val => setDetailForm(val, 'altrDd')"
									:readonly="overInspect"
								/>
							</td>
							<!-- 변경항목(대) -->
							<th>* {{ getMessage_('QWCC000030') }} ②</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.altrPrvsLgrpCd"
									:options="altrLgrpList"
									:onChange="val => setDetailForm(val, 'altrPrvsLgrpCd')"
									:placeholder="getMessage_('QWCC000030')"
									:disabled="noInspect"
								/>
							</td>
							<!-- 샘플수량 -->
							<th>{{ getMessage_('QWCC000031') }}</th>
							<td>
								<el-input
									:clearable="true"
									:value="detailForm.sampQty"
									:disabled="overInspect"
									@input="val => setDetailForm(val, 'sampQty')"
									maxlength="7"
								/>
							</td>
							<!-- 검증일자 -->
							<th>* {{ getMessage_('QWCC000032') }}</th>
							<td>
								<el-date-picker
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:value="detailForm.vrfDd"
									@input="val => setDetailForm(val, 'vrfDd')"
									:readonly="overInspect"
								/>
							</td>
						</tr>
						<tr>
							<!-- 부품분류 -->
							<th>* {{ getMessage_('QWCC000033') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.partClCd"
									:options="getpartClCdListFiltered_"
									:onChange="val => setDetailForm(val, 'partClCd')"
									:placeholder="getMessage_('QWCC000033')"
									:disabled="overInspect"
								/>
							</td>
							<!-- 변경납품일 -->
							<th>* {{ getMessage_('QWCC000034') }}</th>
							<td>
								<el-date-picker
									:value="detailForm.altrDlvgDd"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									@input="val => setDetailForm(val, 'altrDlvgDd')"
									:readonly="overInspect"
								/>
							</td>
							<!-- 변경항목(소) -->
							<th>{{ getMessage_('QWCC000035') }} ③</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.altrPrvsSgrpCd"
									:options="altrSgrpList"
									:onChange="val => setDetailForm(val, 'altrPrvsSgrpCd')"
									:placeholder="getMessage_('QWCC000035')"
									:disabled="noInspect"
								/>
							</td>
							<!-- 검증수량 -->
							<th>{{ getMessage_('QWCC000036') }}</th>
							<td>
								<el-input
									:clearable="true"
									:value="detailForm.vrfQty"
									:readonly="overInspect"
									@input="val => setDetailForm(val, 'vrfQty')"
									maxlength="7"
								/>
							</td>
							<!-- 투입일자 -->
							<th>* {{ getMessage_('QWCC000037') }}</th>
							<td>
								<el-date-picker
									:value="detailForm.trwiDd"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									@input="val => setDetailForm(val, 'trwiDd')"
									:readonly="overInspect"
								/>
							</td>
						</tr>
						<tr>
							<!-- 협력사 -->
							<th>* {{ getMessage_('QWCC000958') }}</th>
							<td class="position-relative">
								<template v-if="detailForm.cofCd">
									{{ detailForm.cofNm || detailForm.cofCd }}
								</template>
								<template v-else-if="detailForm.partNo && !detailForm.altrNo">
									<span style="color: #d3d3d3">{{ getMessage_('QWCC001656') }}</span>
								</template>
								<template v-if="detailForm.partNo && !detailForm.altrNo && isEo4mInnerUser">
									<span class="unit input-icon" @click="onPqyCpnyPopup" v-show="!overInspect"> <i class="icon-sf-search" /> </span>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- 팝업추가 영역 -->
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';

export default {
	data() {
		return {
			isEo4mInnerUser: ''
		};
	},
	components: { PartMngPopup, CompPopup },
	async created() {
		try {
			this.initCombo();
			this.isEo4mInnerUser = !!(this.isPqyAdmin || this.isPqyManager || this.isPqyStaff);
			if (!this.isEo4mInnerUser) {
				if (!this.searchParams.cofCd) {
					throw new Error(this.getMessage_('QWCC001885')); //사용자의 업체 정보를 불러올 수 없습니다. 관리자에게 문의하세요.
				}
				this.setDetailForm_({ key: 'cofCd', value: this.searchParams.cofCd });
				this.setDetailForm_({ key: 'cofNm', value: this.searchParams.cofNm });
			}
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error.message || error });
		}
	},
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		overInspect() {
			// 임시저장, 반려, 등록 상태 일 때,
			return this.detailForm.pgsStCd > 20 || !this.isWriterSelf_;
		},
		noInspect() {
			// 작성 이하의 단계이고, 작성자 본인이거나
			// 검토자는 변경 유형을 변경할 수 있다.
			// 그 조건이 아니면 이 리턴값이 true가 되어 disabled됨
			return !((this.detailForm.pgsStCd <= 20 && this.isWriterSelf_) || this.isPqyManager);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async setDetailForm(value, key) {
			try {
				if (key === 'sampQty' || key === 'vrfQty') {
					value = value?.length > 8 ? value.slice(0, 7) : value;
					value = value.replace(/[^0-9]/g, '');
				}
				this.setDetailForm_({ key, value });
				this.setState_({ key: 'isSaved', value: true });
				if (key === 'altrTypeCd') {
					await this.setAltrLgrpList_();
					this.setDetailForm_({ key: 'altrPrvsLgrpCd', value: '' });
					this.setDetailForm_({ key: 'altrPrvsSgrpCd', value: '' });
					this.setDetailForm_({ key: 'isirCsetScnCd', value: '' });
					if (!this.altrLgrpList.length) this.setDetailForm_({ key: 'isirCsetScnCd', value: '20' });
				} else if (key === 'altrPrvsLgrpCd') {
					await this.setAltrSgrpList_();
					this.setDetailForm_({ key: 'altrPrvsSgrpCd', value: '' });
					this.setDetailForm_({ key: 'isirCsetScnCd', value: '' });
					if (!this.altrSgrpList.length)
						await this.setIsirCsetScn_({ codeType: this.detailForm.altrTypeCd, commCd: this.detailForm.altrPrvsLgrpCd });
				} else if (key === 'altrPrvsSgrpCd') {
					this.setDetailForm_({ key: 'isirCsetScnCd', value: '' });
					await this.setIsirCsetScn_({ codeType: this.detailForm.altrPrvsLgrpCd, commCd: this.detailForm.altrPrvsSgrpCd });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		onPartPopup() {
			this.$refs.partMngPopup.open('', {
				cpnyCd: this.searchParams.cofCd,
				cpnyNm: this.searchParams.cofNm,
				isDisabled: this.isPqyGuest ? 'Y' : 'N'
			});
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			const params = {
				cpnyScn: '10',
				cpnyCd: ''
			};
			this.$refs.compPopup.open(params);
		},
		sendData(param) {
			try {
				if (!this.isEo4mInnerUser && param.cofCd !== this.searchParams.cofCd) {
					throw new Error(this.getMessage_('QWCC002037')); //파트너사의 경우, 본인 소속의 파트너사의 부품만 선택할 수 있습니다.<br />부품 추가를 원할 경우 관리자에게 요청하세요.
				}
				const { langCd } = this.user;
				let partNm = param.chPartNm;
				if (langCd == 'en_US') partNm = param.enPartNm;
				if (langCd == 'ko_KR') partNm = param.koPartNm;

				this.setDetailForm_({ key: 'cofCd', value: param.cofCd });
				this.setDetailForm_({ key: 'oldCofCd', value: param.cofCd });
				this.setDetailForm_({ key: 'cofNm', value: param.cofNm });
				this.setDetailForm_({ key: 'partNo', value: param.partNo });
				this.setDetailForm_({ key: 'partNm', value: partNm });
				this.setDetailForm_({ key: 'partGCd', value: param.partGCd });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			//console.log(this.detailForm.oldCofCd, this.detailForm.cofCd);
			if (this.detailForm.oldCofCd !== cpnyCd) {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'error',
					message: this.getMessage_('QWCC002046'), //부품의 협력사와 선택한 협력사가 다릅니다.<br />계속 진행하시겠습니까?
					buttons: [
						{
							title: 'Ok',
							clickFn: () => {
								this.setDetailForm_({ key: 'cofCd', value: cpnyCd });
								this.setDetailForm_({ key: 'cofNm', value: cpnyNm });
							}
						}
					]
				});
			}
		},
		async initCombo() {
			if (this.detailForm.partNo && this.detailForm.altrNo && this.detailForm.altrTypeCd) {
				await this.setAltrLgrpList_();
				await this.setAltrSgrpList_();
			}
		}
	}
};
</script>
